import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
export default {
  name: "user-update",
  data: function data() {
    return {
      previewDialogVisible: false,
      imageRotateDialogVisible: false,
      imageRotateUrl: "",
      imageRotateKey: "",
      form: {
        avatar: "",
        // 头像
        name: "",
        age: "",
        from: "",
        gender: "",
        occupation: "",
        introduce: "",
        // 个人说明
        album: []
      }
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getUserInfo();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  watch: {
    "form.url": function formUrl() {
      this.form.album.push(this.form.url);
    }
  },
  methods: {
    selectTag: function selectTag(item) {
      item.isSelected = !item.isSelected;
    },
    removeTag: function removeTag(array, index) {
      array.splice(index, 1);
    },
    previewImage: function previewImage(index) {
      var _this2 = this;
      this.previewDialogVisible = true;
      this.$nextTick(function () {
        setTimeout(function () {
          _this2.$refs.carousel.setActiveItem(index);
        });
      });
    },
    closeRotateDialog: function closeRotateDialog() {
      this.imageRotateDialogVisible = false;
    },
    saveRotateImgUrl: function saveRotateImgUrl(url) {
      this.form.album.splice(this.imageRotateKey, 1, url);
    },
    selectRotateImg: function selectRotateImg(key) {
      this.imageRotateKey = key || 0;
      this.imageRotateUrl = this.form.album[this.imageRotateKey];
      this.imageRotateDialogVisible = true;
    },
    removeImgae: function removeImgae(index) {
      this.form.album.splice(index, 1);
    },
    getUserInfo: function getUserInfo() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this3.$api.getUserInfo({
                id: _this3.$route.query.id
              });
            case 1:
              res = _context2.v;
              _this3.form = res.data;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    save: function save() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var form;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              form = JSON.parse(JSON.stringify(_this4.form));
              form.language = [];
              form.tags = [];
              form.footprint = [];
              form.cate = [];
              form.reading = [];
              form.motion = [];
              form.share = [];
              _this4.form.language.forEach(function (item) {
                if (item.isSelected) {
                  form.language.push(item.id ? item.id : item.name);
                }
              });
              _this4.form.tags.forEach(function (item) {
                if (item.isSelected) {
                  form.tags.push(item.id ? item.id : item.name);
                }
              });
              _this4.form.footprint.forEach(function (item) {
                if (item.isSelected) {
                  form.footprint.push(item.id ? item.id : item.name);
                }
              });
              _this4.form.cate.forEach(function (item) {
                if (item.isSelected) {
                  form.cate.push(item.id ? item.id : item.name);
                }
              });
              _this4.form.reading.forEach(function (item) {
                if (item.isSelected) {
                  form.reading.push(item.id ? item.id : item.name);
                }
              });
              _this4.form.motion.forEach(function (item) {
                if (item.isSelected) {
                  form.motion.push(item.id ? item.id : item.name);
                }
              });
              _this4.form.share.forEach(function (item) {
                if (item.isSelected) {
                  form.share.push(item.id ? item.id : item.name);
                }
              });
              _context3.n = 1;
              return _this4.$api.updateUser({
                userId: _this4.$route.query.id,
                update: form
              });
            case 1:
              _this4.$message.success("操作成功");
              // 操作上报
              _this4.$operationLog.push({
                code: "edit_save",
                userId: _this4.$route.query.id,
                operationType: "user",
                detailBatchNo: _this4.$route.query.id
              });
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    }
  }
};